import React from "react";

export interface IndexContentAreaProps {

	children?: React.ReactNode;

}

const IndexContentArea: React.FC<IndexContentAreaProps> = (props: IndexContentAreaProps) => {

	return (
		<div id="indexcontentarea-container" className="p-4 md:col-start-2 w-full min-h-screen xl:pt-16 xl:pl-32 xl:pr-32 overflow-y-auto">
			{props.children}
		</div>
	);

};

export default IndexContentArea;